import { makeStyles } from '@material-ui/core';

import { RiArrowDownSLine, RiNewsLine, RiQuestionLine } from '@remixicon/react';

import { Button, ButtonIcon, Skeleton } from '@backstage/ui';

import {
  ConfidenceLogoInverted,
  ConfidenceWebsiteLink,
  FeatureFlagged,
  Hidden,
} from '@spotify/confidence-core-react';
import {
  AppAccountSwitcher,
  AppHeader,
  AppSearchBar,
} from '@spotify/plugin-confidence-app-react';

import { DemoModeChip } from '../DemoModeChip';
import { TrialChip } from '../TrialChip';

const useStyles = makeStyles({
  root: {},
  links: {
    display: 'flex',
    alignItems: 'center',
    // 1px to give SOME distance
    gap: 1,
  },
});

export const Header = () => {
  const classes = useStyles();

  return (
    <AppHeader.Root className={classes.root}>
      <AppHeader.Brand
        to="/"
        icon={
          <ConfidenceLogoInverted color="inherit" style={{ fontSize: 28 }} />
        }
        text="Confidence"
      />
      <FeatureFlagged with="trial-banner">
        <TrialChip />
      </FeatureFlagged>
      <DemoModeChip />
      <AppHeader.Search>
        <AppSearchBar />
      </AppHeader.Search>
      <AppHeader.Aux>
        <div className={classes.links}>
          <Hidden xsDown>
            <ConfidenceWebsiteLink
              aria-label="Documentation"
              route="/docs"
              color="inherit"
            >
              <ButtonIcon variant="tertiary" icon={<RiQuestionLine />} />
            </ConfidenceWebsiteLink>
          </Hidden>
          <Hidden smDown>
            <ConfidenceWebsiteLink aria-label="Blog" route="/blog">
              <ButtonIcon variant="tertiary" icon={<RiNewsLine />} />
            </ConfidenceWebsiteLink>
          </Hidden>

          <AppAccountSwitcher>
            {({ selectedAccount, isLoading, isSwitching }) =>
              selectedAccount && !isLoading && !isSwitching ? (
                <Button variant="tertiary" iconEnd={<RiArrowDownSLine />}>
                  {selectedAccount.displayName}
                </Button>
              ) : (
                <Skeleton height={32} width={100} />
              )
            }
          </AppAccountSwitcher>
        </div>

        <FeatureFlagged with="aa-test">{null}</FeatureFlagged>
      </AppHeader.Aux>
    </AppHeader.Root>
  );
};
